import { UsdtUri } from '../../core/configs/services';
import { AdminResponse } from '../models/adminResponse';
import adminRequest from '../../../config/adminRequest';

export type TokenRowType ={
  channel:string,
  token:string,
  transferInfo:string;
  minimumAmount: number,
  collectDest:string
}

export interface TokenSettingType {
  active: boolean,
  collectDest: string,
  minimumAmount: number,
  collectDestType?: 'PAYOUT' | 'MCH',
}

export type TokenSetting = {
  [channel: string]: {
    [token: string]: TokenSettingType;
  };
}

export type NumberComponentType = {
  [id:string]:  number,
}

export type StringComponentType = {
  [id:string]:  string,
}

export type NetworkSetting = {
  [channel: string]: {
    [token: string]: {
      transferMode: string,
      staticFee?: number
    }
  };
}

export interface CollectSetting {
  systemId: string;
  tokenSetting: TokenSetting;
  networkFeeSetting: NetworkSetting;
}

export interface CollectDestPreview {
  collectOnly: boolean;
  destType: 'PAYOUT' | 'MCH';
  address: string | null;
  mchWalletCount: number;
}

/**
 * 三態,取代原本 `CollectDestPreview | undefined`(undefined 同時代表「還在載入」
 * 與「載入失敗」,導致載入中的畫面會直接顯示「載入失敗」文案)。
 *
 * 'loading' 也用來在切換商戶時重置畫面 —— effect 一進來就先設回 'loading',
 * 避免開完商戶 A 再開商戶 B 時,B 的 Spin 已結束但短暫顯示 A 殘留的
 * collectOnly/mchWalletCount(下拉可選性)與地址欄(DB 殘留值)。
 */
export type CollectDestPreviewState = 'loading' | 'failed' | CollectDestPreview;

export default class CollectSettingProvider {

  static async getSetting(systemId: string) {
    const result = await adminRequest.get<AdminResponse<CollectSetting>>(
      UsdtUri(`admin/collect/setting/${systemId}`),
      {
        headers: {
          SYSTEM_ID: systemId,
        },
      },
    );
    return result.data.data;
  }

  static async updateSetting(data: CollectSetting) {
    const result = await adminRequest.put<AdminResponse<CollectSetting>>(
      UsdtUri(`admin/collect/setting/`),
      data,
    );
    return result.data.data;
  }

  static async getDestPreview(systemId: string) {
    const result = await adminRequest.get<AdminResponse<CollectDestPreview>>(
      UsdtUri(`admin/collect/setting/${systemId}/dest-preview`),
      {
        headers: {
          SYSTEM_ID: systemId,
        },
      },
    );
    return result.data.data;
  }

}
